import { Middleware, ResponseContext } from "@wingspanhq/wingspan-api-sdk";
import { sessionService } from "@services/sessionService";
import { tokenStore } from "@services/tokenStore";

export const authRefreshMiddleware: Middleware = {
  post: async (context: ResponseContext): Promise<Response | void> => {
    if (context.response.status !== 401) {
      return;
    }

    // An impersonation token is short-lived and has no refresh token of its
    // own, so refreshing here would mint an admin token and silently rerun the
    // request as the admin while the UI still claims to impersonate. Drop the
    // impersonation instead and let the 401 surface: the app re-renders as the
    // admin, which is the honest outcome of an expired or revoked session.
    if (tokenStore.isImpersonating()) {
      tokenStore.clearImpersonation();
      return;
    }

    try {
      await sessionService.refreshAccessToken();
    } catch {
      tokenStore.clear();
      return;
    }

    const retryHeaders = new Headers(context.init.headers);
    retryHeaders.set(
      "Authorization",
      `Bearer ${tokenStore.getAccessToken() ?? ""}`
    );

    // Retried through context.fetch so the rest of the middleware chain still
    // applies to the new request.
    return context.fetch(context.url, {
      ...context.init,
      headers: retryHeaders
    });
  }
};
